var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNoteBentCorner = function SvgNoteBentCorner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43.611,
    height: 56.776,
    viewBox: "0 0 43.611 56.776",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_717603_cc",
    opacity: 0.505
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1581",
    "data-name": "Group 1581",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M9.539,1.239A4.993,4.993,0,0,0,4.366,6.014V53.238a4.993,4.993,0,0,0,5.173,4.778H42.807a4.991,4.991,0,0,0,5.17-4.778v-35.5a4.569,4.569,0,0,0-1.514-3.377L33.774,2.64a5.362,5.362,0,0,0-3.656-1.4H9.539ZM32.823,4.268,44.7,15.237h-9.47a2.324,2.324,0,0,1-2.408-2.224V4.268Zm2.408,12.745H45.952a2.792,2.792,0,0,1,.106.726v35.5a3.136,3.136,0,0,1-3.251,3H9.539a3.137,3.137,0,0,1-3.251-3V6.017a3.138,3.138,0,0,1,3.251-3H30.118a3.5,3.5,0,0,1,.783.1v9.9A4.179,4.179,0,0,0,35.231,17.013Z",
    transform: "translate(-4.366 -1.239)",
    fill: "#4a5762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M32.711,13.562H8.362a.889.889,0,1,0,0,1.773H32.708a.889.889,0,1,0,0-1.773Z",
    transform: "translate(1.271 18.948)",
    fill: "#4a5762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M7.4,11.1a.924.924,0,0,0,.96.886H32.708a.889.889,0,1,0,0-1.773H8.362A.927.927,0,0,0,7.4,11.1Z",
    transform: "translate(1.271 13.464)",
    fill: "#4a5762"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M32.711,16.909H8.362a.889.889,0,1,0,0,1.773H32.708a.889.889,0,1,0,0-1.773Z",
    transform: "translate(1.271 24.431)",
    fill: "#4a5762"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoteBentCorner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noteBentCorner.117567ae.svg";
export { ForwardRef as ReactComponent };